import AutomatizacImg from '../assets/images/automatizac.png';
import BelowImg from '../assets/images/below.png';
import CreditBookImg from '../assets/images/creditbook.png';
import CucaraMatchaImg from '../assets/images/cucara-matcha.png';
import DarecoImg from '../assets/images/dareco.png';
import EstandarImg from '../assets/images/estandar.png';
import HACCleaningImg from '../assets/images/hac-cleaning.png';
import HuycesImg from '../assets/images/huyces.png';
import MicrocontrollersImg from '../assets/images/microcontrollers.png';
import MrParkingImg from '../assets/images/mr-parking.png';
import PrevenautoImg from '../assets/images/prevenauto.png';
import ProfilePhoto from '../assets/images/profile-photo.png';
import ProsegurosImg from '../assets/images/proseguros.png';
// import RailaImg from '../assets/images/raila.png';
import RedGalenaImg from '../assets/images/red-galena.png';
import SegurosQualitasImg from '../assets/images/seguros-qualitas.png';
import ServipImg from '../assets/images/servip.png';
import SuptrimzaImg from '../assets/images/suptrimza.png';
import Sysge24Img from '../assets/images/sysge24.png';
import TaxealoImg from '../assets/images/taxealo.png';
import TecnoImg from '../assets/images/tecno.png';

// APK's
import CreditBookAPK from '../assets/apk/CreditBook.apk';

export const data = {
  "profile_photo": ProfilePhoto,
  "about": "I am a software developer with 10 years of experience. I am passionate about creating visually striking, intuitive, scalable, and high-quality software with added value. I have extensive experience developing full web and mobile applications with technologies such as React.js, React Native, Flutter and Nest.js. Also, I am always on personal side projects that allow me to learn about new tools and techniques that can improve the development process and ensure the quality of the final product.",
  "skills": [
    "React.js",
    "React Native",
    "Next.js",
    "Qwik",
    "Flutter",
    "TypeScript",
    "Tailwind CSS",
    "SASS",
    "Nest.js",
    "Node.js",
    "Express.js",
    "PHP",
    "Laravel",
    "SQL",
    "Git",
    "Redux",
    "Socket.io"
  ],
  "experience": [
    {
      "position": "Web/App Front end Developer",
      "enterprise": "Limónbyte",
      "location": "Aragua, VE",
      "from": "Feb 2022",
      "until": "Currently",
      "goals": [
        "I have implemented interfaces and functionalities in mobile and web applications, the projects were created from scratch.",
        "I have supported the back-end team in technologies such as Laravel/Nest.js to complement the required functionality in the front-end and also improve workflow.",
        "Up to this point, I have participated in more than 20 projects within the company"
      ],
      "goals_es": [
        "He Implementado interfaces y funcionalidades en aplicaciones móviles y web y en algunos casos los proyectos fueron creados desde cero.",
        "He apoyado al equipo de back-end en tecnologías como Laravel/Nest.js para complementar las funcionalidades requeridas en el front-end y también mejorar el flujo de trabajo.",
        "Hasta el momento he participado en más de 20 proyectos dentro de la empresa."
      ],
    },
    {
      "position": "Fullstack Developer",
      "enterprise": "Andysoft IT Services",
      "location": "Zacatecas, MX",
      "from": "Sep 2020",
      "until": "Feb 2022",
      "goals": [
        "I developed ERP and POS systems from scratch, hybrid mobile applications, functionalities, and maintenance in different web systems.",
        "I developed an MVC structure in pure PHP and implemented it in existing projects and new developments to replace the inefficient file structure.",
        "I was responsible for developing the workflow and structuring the databases of the applications",
      ],
      "goals_es": [
        "Desarrollé sistemas ERP y POS desde cero, aplicaciones móviles híbridas, funcionalidades y mantenimiento en distintos sistemas web.",
        "Desarrollé una estructura MVC en PHP puro y lo implementé en los proyectos existentes y en los nuevos desarrollos para sustituir la ineficiente estructura de archivos.",
        "Fui el responsable de desarrollar el flujo de trabajo y la estructuración de las bases de datos de las aplicaciones.",
      ],
    },
    {
      "position": "Freelance Software Developer",
      "enterprise": "Alcaldía de Zamora",
      "location": "Miranda, VE",
      "from": "Mar 2020",
      "until": "Sep 2020",
      "goals": [
        "As a part-time job, I was hired to develop a tax system for one of the municipalities in the state. It has an environment for taxpayers and another for the employees of the tax-collecting company.",
        "Despite not having any prior knowledge of Angular, I accepted the challenge and was able to achieve the required objective.",
        "I designed and developed the entire functional structure of the system from scratch."
      ],
      "goals_es": [
        "Como trabajo de medio tiempo fui contratado para desarrollar un sistema tributario para uno de los municipios del estado. El mismo posee un entorno para contribuyentes y otro para los empleados de la empresa recaudadora.",
        "A pesar de no tener conocimientos en Angular, acepté y reto y pude lograr el objetivo que se requería.",
        "Diseñé y desarrollé toda la estructura funcional del sistema desde cero."
      ],
    },
    {
      "position": "Development and Database Coordinator",
      "enterprise": "SITSSA",
      "location": "Caracas, VE",
      "from": "Dec 2017",
      "until": "Feb 2021",
      "goals": [
        "I started as a developer and was later promoted to Coordinator of the Development and Database department.",
        "I managed several legacy administrative systems of the company and participated in the migration and unification of these to a new system."
      ],
      "goals_es": [
        "Ingresé como desarrollador y en el transcurso fui ascendido a Coordinador del área de Desarrollo y Base de Datos.",
        "Administré varios sistemas legacy administrativos de la empresa y participé en la migración y unificación de estos a un sistema nuevo."
      ],
    },
  ],
  "work": [
    {
      "title": "Seguros Qualitas",
      "overline": "Featured Project",
      "description": "It is an app that allows Seguros Qualitas policyholders to carry out procedures and queries regarding their policies quickly and easily, as well as being able to request assistance in the event of an accident, among other features. It consists of an app for policyholders, as well as a web version of the app and an administrative website for the company's employees.",
      "description_es": "Es una app que permite a los asegurados de Seguros Qualitas realizar trámites y consultas de sus pólizas de forma rápida y sencilla, además de poder solicitar asistencia en caso de siniestro, entre otras funcionalidades. Consta de una app para los asegurados, también una versión web de la app y una web administrativa para los empleados de la empresa.",
      "image": SegurosQualitasImg,
      "technologies": [
        "React Native",
        "React.js",
        "Nest.js",
        "TailwindCSS"
      ],
      "links": [
        {
          "title": "Seguros Qualitas | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.limonbyte.seguros"
        },
        {
          "title": "Seguros Qualitas | WebApp",
          "icon": "web",
          "url": "https://appweb.seguros-qualitas.com"
        }
      ],
    },
    {
      "title": "Proseguros",
      "overline": "Featured Project",
      "description": "It is an app that allows Proseguros policyholders to carry out procedures and queries regarding their policies quickly and easily, as well as being able to request assistance in the event of an accident, among other features. It consists of an app for policyholders, as well as a web version of the app and an administrative website for the company's employees.",
      "description_es": "Es una app que permite a los asegurados de Proseguros realizar trámites y consultas de sus pólizas de forma rápida y sencilla, además de poder solicitar asistencia en caso de siniestro, entre otras funcionalidades. Consta de una app para los asegurados, también una versión web de la app y una web administrativa para los empleados de la empresa.",
      "image": ProsegurosImg,
      "technologies": [
        "React Native",
        "React.js",
        "Nest.js",
        "TailwindCSS"
      ],
      "links": [
        // {
        //   "title": "Proseguros | Google Play",
        //   "icon": "google-play",
        //   "url": "https://play.google.com/store/apps/details?id=com.limonbyte.proseguros"
        // },
        // {
        //   "title": "Proseguros | WebApp",
        //   "icon": "web",
        //   "url": "https://appweb.seguros-qualitas.com"
        // }
      ],
    },
    {
      "title": "Red Galena",
      "overline": "Featured Project",
      "description": "This is an app for managing both online and in-person medical consultations. It enables messaging and video calls between all parties involved. Additionally, it features a corporate profile that allows companies to purchase medical consultations for their employees. The ecosystem consists of dedicated apps for doctors, patients, and companies, as well as an administrative web portal for Red Galena staff.",
      "description_es": "Es una app para gestionar consultas médicas online y presenciales. Permite enviar mensajes y videoconsultas entre los involucrados. También posee un perfil de empresa el cual permite a las mismas adquirir consultas médicas para sus empleados. Consta de una app para los médicos, pacientes y empresas, también una web administrativa para el personal de Red Galena.",
      "image": RedGalenaImg,
      "technologies": [
        "React Native",
        "React.js",
        "Nest.js",
        "SASS"
      ],
      "links": [
        {
          "title": "Red Galena | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.limonbyte.redgalena"
        },
      ],
    },
    {
      "title": "Estándar",
      "overline": "Featured Project",
      "description": "It is an online store featuring a Visual Product Configurator, which allows users to see their selected options in real time. This functionality was built from scratch using reverse engineering. The system consists of the e-commerce storefront and an administrative panel for the store manager.",
      "description_es": "Es una tienda online con la particularidad de poseer un Configurador Visual de Producto, el cual permite ver en tiempo real las opciones seleccionadas por el usuario. Funcionalidad realizada desde cero con ingeniería inversa. Consta de una tienda online y una web administrativa para el administrador de la tienda.",
      "image": EstandarImg,
      "technologies": [
        "React Native",
        "React.js",
        "Nest.js",
        "TailwindCSS"
      ],
      "links": [
        {
          "title": "Estandar | Tienda Online",
          "icon": "web",
          "url": "https://estandar.com"
        }
      ],
    },
    {
      "title": "HAC Cleaning",
      "overline": "Featured Project",
      "description": "It is a cleaning services management app which involves verifying the employee's location at the time of starting a job, uploading photos of the service, and calculating payroll based on the hours worked. Visual reports of the services performed are generated from the administrator's website.",
      "description_es": "Es una app de gestión de servicios de limpieza el cual involucra la verificación de la ubicación del empleado al momento de iniciar un trabajo, subida de fotos del servicio, cálculo de nómina en base al horario trabajado. Desde la web del administrador se generan reportes visuales de los servicios realizados.",
      "image": HACCleaningImg,
      "technologies": [
        "React Native",
        "React.js",
        "Nest.js",
        "TailwindCSS"
      ],
      "links": [
        {
          "title": "HAC Cleaning | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.limonbyte.haccleaning"
        }
      ],
    },
    {
      "title": "SIAT: Sistema Integrado de Administración Tributaria (Taxes)",
      "overline": "Featured Project",
      "description": "This system is the most relevant in my project list, since all the business logic, calculations, and extensive forms were created from scratch in a technology that I had no knowledge of (Angular), but I was able to easily adapt. The most satisfying part is knowing that it was used by thousands of users",
      "description_es": "Este sistema es el más relevante en mi lista de proyectos, ya que se creó desde cero toda la lógica de negocio, los cálculos y sus extensos formularios en una tecnología de la cual no tenía conocimiento (Angular) pero fácilmente pude adaptarme. Lo más satisfactorio es saber que fue usado por miles de usuarios",
      "image": SuptrimzaImg,
      "technologies": [
        "Angular",
        "PHP",
        "SQL"
      ],
      "links": [],
    },
    {
      "title": "Sysge24",
      "overline": "Featured Project",
      "description": "It is an ERP that consists of 3 parts: administrative website, mobile app and public store, the latter being developed from scratch by me, which is used to place orders, and it is possible to send them via WhatsApp. I also had to implement improvements in the front end and back end administrative web, in addition to migrating existing functionalities in the mobile app to the web. In the mobile app I had to carry out a partial redesign",
      "description_es": "Es un ERP que consta de 3 partes: Web administrativa, app móvil y tienda pública, siendo esta última desarrollada desde cero por mí, el cual sirve para realizar pedidos, siendo posible enviar estos mediante WhatsApp. También me tocó implementar mejoras en la web administrativa de front end y back end, además de migrar funcionalidades existentes en la app móvil hacia la web. En la app móvil me tocó realizar un rediseño parcial",
      "image": Sysge24Img,
      "technologies": [
        "React Native",
        "React.js",
        "Laravel",
        "Firebase",
        "Socket.io",
        "Redux",
        "SCSS"
      ],
      "links": [
        {
          "title": "Sysge24 | Web",
          "icon": "web",
          "url": "https://sysge24.com"
        },
        {
          "title": "Sysge24 | App Store",
          "icon": "app-store",
          "url": "https://apps.apple.com/gw/app/sysge24/id1625740493"
        },
        {
          "title": "Sysge24 | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.sysge24"
        }
      ],
    },
    {
      "title": "Prevenauto",
      "overline": "Featured Project",
      "description": "Is an application for the registration of fuel and mileage for the fleet of vehicles. I was in charge of creating most of the screens for the different environments based on a provided design",
      "description_es": "Es una aplicación para el registro de combustible y kilometraje de la flota de vehículos. Me encargué de realizar la mayoría de las pantallas para los diferentes entornos basándome en un diseño proporcionado",
      "image": PrevenautoImg,
      "technologies": [
        "React Native",
        "Laravel",
        "Redux"
      ],
      "links": [
        {
          "title": "Prevenauto | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.limonbyte.flota"
        }
      ],
    },
    {
      "title": "Dareco",
      "overline": "Featured Project",
      "description": "It is an app that complements a web store created with Wordpress and WooCommerce. I implemented functionalities that allowed from the app to create customers and authenticate them, place orders, manage shipping costs based on the customer's location and manage products with variants",
      "description_es": "Es una app que complementa una tienda web creada con Wordpress y WooCommerce. Implementé funcionalidades que permitieron desde la app crear clientes y autenticarlos, realizar los pedidos, gestionar costos de envío basándome en la ubicación del cliente y manejo de productos con variantes",
      "image": DarecoImg,
      "technologies": [
        "React Native",
        "React.js",
        "Vue",
        "Laravel",
        "Firebase",
        "Socket.io",
        "Redux"
      ],
      "links": [
        {
          "title": "Dareco | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.limonbyte.dareco"
        },
        {
          "title": "Dareco | Web",
          "icon": "web",
          "url": "https://darecoweb.com"
        }
      ],
    },
    {
      "title": "Tecno",
      "overline": "Featured Project",
      "description": "Tecno allows for organizing customer orders in advance. It has a web app that handles logistics, users, products, order processing, cash management, etc. I participated in all the front-end work for both apps",
      "description_es": "Tecno permite organizar los pedidos de los clientes por anticipado. Posee una app web que se encarga de la logística, los usuarios, productos, procesar los pedidos, cierres de caja, etc. Participé en todo el front end de ambas apps",
      "image": TecnoImg,
      "technologies": [
        "React Native",
        "React.js",
        "Laravel",
        "Firebase",
        "Socket.io",
        "Redux",
        "SCSS"
      ],
      "links": [
        {
          "title": "Tecno | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.limonbyte.gestionsabasic"
        }
      ],
    },
    {
      "title": "Taxealo",
      "overline": "Featured Project",
      "description": "Taxealo is an app like Uber. It started from a base project and several apps emerged with different names and different characteristics. I implemented the Taxealo and Liberty redesign in their Passenger and Driver versions. I also participated in implementations and adjustments of the administrative web part and the back end",
      "description_es": "Taxealo es una app como Uber. Partió desde un proyecto base y surgieron varias apps con diferentes nombres y características distintas. Implementé el rediseño de Taxealo y Liberty en sus versiones de Pasajero y Conductor. También participé en implementaciones y ajustes de la parte web administrativa y el back end",
      "image": TaxealoImg,
      "technologies": [
        "React Native",
        "React.js",
        "Vue",
        "Laravel",
        "Firebase",
        "Socket.io",
        "Redux"
      ],
      "links": [
        {
          "title": "Taxealo Pasajero | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.limonbyte.taxea"
        },
        {
          "title": "Taxealo Conductor | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.limonbyte.taxeaconductor"
        },
        {
          "title": "Yesgo | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.yesgo"
        },
        {
          "title": "Liberty | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.limonbyte.liberty"
        }
      ],
    },
    {
      "title": "Below",
      "overline": "Featured Project",
      "description": "Below is a system for managing professional technical service for preventative and corrective maintenance of air conditioning, which has a mobile and web app. I developed all the screens for the web and a large part of its functionalities. I also participated in some screens and details on the mobile app, including the iOS version, as well as some adjustments in the back end",
      "description_es": "Below es un sistema para administrar servicio técnico profesional de mantenimiento preventivo y correctivo de aire acondicionado. El cual posee una app móvil y web. Desarrollé todas las pantallas de la web y gran parte de sus funcionalidades. Participé en algunas pantallas y detalles en la app móvil, incluyendo la versión para iOS y también en algunos ajustes en back end",
      "image": BelowImg,
      "technologies": [
        "React Native",
        "React.js",
        "TypeScript",
        "Nest.js",
        "Firebase",
        "Socket.io",
        "Redux",
        "SCSS"
      ],
      "links": [
        {
          "title": "Below | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.limonbyte.below"
        }
      ],
    },
    {
      "title": "SerVIP",
      "overline": "Featured Project",
      "description": "SerVIP is an app where you can search business directories by categories, states and cities. I developed all the screens based on a layout provided and after a while they asked me to implement a complete redesign",
      "description_es": "SerVIP es una app en la que puedes buscar directorios comerciales por categorías, estados y ciudades. Desarrollé todas las pantallas basándome en un diseño proporcionado y al cabo de un tiempo me solicitaron implementar un rediseño completo",
      "image": ServipImg,
      "technologies": [
        "React Native",
        "React.js",
        "Nest.js",
        "Firebase",
        "Socket.io",
        "Redux"
      ],
      "links": [
        {
          "title": "SerVIP | Google Play",
          "icon": "google-play",
          "url": "https://play.google.com/store/apps/details?id=com.servip.app"
        }
      ],
    },
    {
      "title": "Mr. Parking",
      "overline": "Side Project (In Progress)",
      "description": "Mr. Parking is an app whose main objective is to locate parking spots in real-time, depending on the type of vehicle the driver has. And as a business model, a store is implemented that is focused on all types of vehicles",
      "description_es": "Mr. Parking es una app cuyo objetivo principal es ubicar estacionamientos en tiempo real, dependiendo del tipo de vehículo del conductor. Y como modelo de negocio, se implementa una tienda orientada a todo tipo de vehículo",
      "image": MrParkingImg,
      "technologies": [
        "Flutter",
        "Nest.js",
        "Firebase",
        "Socket.io"
      ],
      "links": [
        // {
        //   "title": "Mr. Parking | APK",
        //   "icon": "android",
        //   "url": "https://play.google.com/store/apps/developer?id=Prusked"
        // }
      ],
    },
    // {
    //   "title": "Raila: Language Assistant",
    //   "overline": "Side Project",
    //   "description": "Raila is an app powered by Chat GPT that helps to remember and implement words in different languages ​​with the frequent sending of reminders in the form of notifications",
    //   "description_es": "Raila es una app potenciada con Chat GPT que ayuda a recordar e implementar palabras en distintos idiomas con el envío frecuente de recordatorios en forma de notificaciones",
    //   "image": RailaImg,
    //   "technologies": [
    //     "Flutter",
    //     "Chat GPT"
    //   ],
    //   "links": [
    //     // {
    //     //   "title": "Raila | Google Play",
    //     //   "icon": "google-play",
    //     //   "url": "https://play.google.com/store/apps/details?id=com.prusked.raila"
    //     // }
    //   ],
    // },
    {
      "title": "CreditBook",
      "overline": "Side Project",
      "description": "CreditBook is an app to manage personal loans, whose color palette was inspired by Binance. It was the first app I created after completing the React Native course.",
      "description_es": "CreditBook es una app para administrar los préstamos personales, cuya paleta de colores fue inspirada por Binance. Fue la primera app que creé luego de realizar el curso de React Native",
      "image": CreditBookImg,
      "technologies": [
        "React Native",
        "TypeScript",
      ],
      "links": [
        {
          "title": "CreditBook | APK",
          "icon": "android",
          "url": CreditBookAPK
        }
      ],
    },
    {
      "title": "Automatizac",
      "overline": "Featured Project",
      "description": "Automatizac is an ERP for the administration of installation, service and maintenance contracts for electric gates. It was created from scratch and made up of a web app and a mobile app, which allows the technician to manage their service calendar and report work done",
      "description_es": "Automatizac es un ERP para la administración de contratos de instalación, servicio y mantenimiento a portones eléctricos. Fue creado desde cero y constituido por una app web y una app móvil, la cual le permite al técnico gestionar su calendario de servicios y reportar trabajos realizados",
      "image": AutomatizacImg,
      "technologies": [
        "Angular.js",
        "PHP",
        "SQL",
        "Cordova"
      ],
      "links": [
        {
          "title": "Automatizac | Web",
          "icon": "web",
          "url": "https://www.automatizac.com.mx/"
        }
      ],
    },
    {
      "title": "Cucara-Matcha Restaurant POS",
      "overline": "Featured Project",
      "description": "It is a POS which connects to a multi-environment mobile app in real time to send orders to the kitchen, notify the status of orders, reserve tables, control input costs through recipes for dishes and products, warehouse management and orders to suppliers. It was designed and created all from scratch entirely by me",
      "description_es": "Es un POS el cual se conecta a una app móvil multientornos en tiempo real para enviar los pedidos a la cocina, notificar el estatus de pedidos, reserva de mesas, control de gastos de insumos mediante las recetas de los platillos y productos, gestión de almacenes y pedidos a proveedores. Fue diseñado y creado todo desde cero enteramente por mí",
      "image": CucaraMatchaImg,
      "technologies": [
        "Angular.js",
        "PHP",
        "SQL",
        "Socket.io"
      ],
      "links": [],
    },
    {
      "title": "Huyces",
      "overline": "Featured Project",
      "description": "It is an ERP which connects to a mobile app that allows sellers to place orders offline and view customers on the map by daily itinerary. Internally, the web app has an error manager, which notifies them through a Telegram bot. It was created all from scratch entirely by me.",
      "description_es": "Es un ERP el cual se conecta a una app móvil que permite a los vendedores realizar pedidos de forma offline y visualizar clientes en el mapa por itinerario diario. Internamente, la app web posee un gestor de errores la cual los notifica mediante un bot de Telegram. Fue creado todo desde cero enteramente por mí",
      "image": HuycesImg,
      "technologies": [
        "Angular.js",
        "PHP",
        "SQL",
      ],
      "links": [],
    },
    {
      "title": "PIC Microcontrollers Multiporpuse Software",
      "overline": "Featured Project",
      "description": "In my Github profile you can find multiple projects related to PIC microcontrollers, which have been developed entirely by me and some of them I have used in commercial projects. Others were reverse-engineered for educational purposes to replicate the operation of equipment that I myself assembled in a company I worked for in 2016",
      "description_es": "En mi perfil de Github podrás encontrar múltiples proyectos relacionados con microcontroladores PIC, los cuales han sido desarrollados enteramente por mí y algunos de ellos los he usado en proyectos comerciales. Otros fueron realizados mediante ingeniería inversa con fines educativos para replicar el funcionamiento de equipo que yo mismo ensamblaba en una empresa para la cual trabajé en el año 2016",
      "image": MicrocontrollersImg,
      "technologies": [
        "C",
        "CCS Compiler",
        "Proteus",
        "CadSoft Eagle",
      ],
      "links": [
        {
          "title": "Repositorios | Github",
          "icon": "web",
          "url": "https://github.com/cesargillao"
        }
      ],
    }
  ]
};